import { cn } from '@/lib/utils'
import { FormControlLabel, Checkbox as MuiCheckbox } from '@mui/material'
import { HTMLAttributes } from 'react'

interface IProps
    extends Omit<HTMLAttributes<HTMLButtonElement>, 'onChange' | 'color'> {
    checked?: boolean
    onChange?: (
        event: React.ChangeEvent<HTMLInputElement>,
        checked: boolean,
    ) => void
}

export default function CheckboxBase({
    checked,
    onChange,
    children,
    className,
    ...props
}: IProps) {
    return (
        <div className={cn('select-none', className)}>
            <FormControlLabel
                control={
                    <MuiCheckbox
                        checked={checked}
                        onChange={onChange}
                        {...props}
                    />
                }
                label={
                    <div className="inline-flex items-center">{children}</div>
                }
                labelPlacement="end"
            />
        </div>
    )
}
